/**
 * True for the replay interpreter's own step observation — a bare `replayed` or
 * `replayed — verified: …` (verification evidence the worker builds into the replay bundle). This
 * is internal QA detail: it renders only in the admin console, never in the agent interface —
 * step rows, the downloadable PDF report, and the failure digest all filter it out. An agent/LLM
 * step observation is shown to everyone. Match is case-insensitive, tolerant of leading
 * whitespace, and anchored on a word boundary so a QA-only line can't leak.
 */
export function isReplayObservation(observation?: unknown): boolean {
  return typeof observation === 'string' && /^\s*replayed\b/i.test(observation);
}

/**
 * A step observation as shown in the agent interface: the replay interpreter's own lines are
 * hidden (returned as an empty string), everything else passes through.
 */
export function agentObservation(observation?: unknown): string {
  if (typeof observation !== 'string' || isReplayObservation(observation))
    return '';
  return observation;
}
